(function () {
  'use strict';
  function send(name, params) {
    if (typeof window.gtag === 'function') window.gtag('event', name, params || {});
  }
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Design C markup comes verbatim from the app. Links that carry data-ci-event keep it;
  // links without one are classified here so the GA events stay the same as v37.
  function eventFor(link) {
    if (link.dataset.ciEvent) return link.dataset.ciEvent;
    if (link.closest('.simc, .sc-card')) return 'sci_similar_click';
    if (link.closest('.vgrid') || link.classList.contains('vt')) return 'sci_video_click';
    if (link.classList.contains('chip') && link.classList.contains('link')) return 'sci_thread_click';
    return null;
  }

  // Similar-perfumes carousel (the only sideways scroller in design C): arrows + disabled ends.
  function bindCarousel(wrap) {
    var scroller = wrap.querySelector('.scroller');
    if (!scroller) return;
    var buttons = wrap.querySelectorAll('.arrows button');
    if (buttons.length < 2) return;
    var prev = buttons[0];
    var next = buttons[buttons.length - 1];
    function step() {
      var card = scroller.firstElementChild;
      if (!card) return 260;
      var gap = parseFloat(getComputedStyle(scroller).columnGap) || 0;
      return card.getBoundingClientRect().width + gap;
    }
    function update() {
      var max = scroller.scrollWidth - scroller.clientWidth - 2;
      prev.disabled = scroller.scrollLeft <= 2;
      next.disabled = scroller.scrollLeft >= max;
      wrap.classList.toggle('ci-no-scroll', max <= 0);
    }
    [prev, next].forEach(function (button) {
      if (button.hasAttribute('onclick')) button.removeAttribute('onclick');
      button.type = 'button';
      button.addEventListener('click', function () {
        var dir = button === prev ? -1 : 1;
        scroller.scrollBy({ left: dir * step(), behavior: reduceMotion ? 'auto' : 'smooth' });
      });
    });
    scroller.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init(root) {
    if (root.dataset.ciBound) return;
    root.dataset.ciBound = 'true';
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) {
          send('sci_view');
          observer.disconnect();
        }
      });
      observer.observe(root);
    } else {
      send('sci_view');
    }
    root.querySelectorAll('details').forEach(function (details) {
      // Native toggle may fire for the initial open attribute. Track closed → open only.
      var wasOpen = details.open;
      details.addEventListener('toggle', function () {
        if (details.open && !wasOpen) send('sci_details_open', { id: details.id || details.className });
        wasOpen = details.open;
      });
    });
    root.querySelectorAll('.rowwrap').forEach(bindCarousel);
    root.addEventListener('click', function (event) {
      var link = event.target.closest('a');
      if (!link || !root.contains(link)) return;
      var name = eventFor(link);
      if (name) send(name);
    });
  }
  document.querySelectorAll('[data-ci-section]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-ci-section]').forEach(init);
  });
})();
